import { useRef, useEffect } from 'react';
import { MDCCircularProgress } from '@material/circular-progress';

const CircularProgress = () => {

    const ref = useRef(null);
    const componentRef = useRef(null);
    
    useEffect(() => {
        if (!componentRef.current && ref.current) {
            componentRef.current = new MDCCircularProgress(ref.current);
            componentRef.current.progress = 0.5;
            componentRef.current.determinate = false;
            componentRef.current.open();
        }

        return () => {
            if(componentRef.current){
                componentRef.current.close();
                componentRef.current.destroy();
                componentRef.current = null;
            }
        }
    }, []);

    return (
            <div ref={ref} className="mdc-circular-progress" style={{width:"48px", height:"48px"}} role="progressbar" aria-label="Progress Bar" aria-valuemin="0" aria-valuemax="1">
                <div className="mdc-circular-progress__determinate-container">
                    <svg className="mdc-circular-progress__determinate-circle-graphic" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                        <circle className="mdc-circular-progress__determinate-track" cx="24" cy="24" r="18" strokeWidth="4" />
                        <circle className="mdc-circular-progress__determinate-circle" cx="24" cy="24" r="18" strokeDasharray="113.097" strokeDashoffset="113.097" strokeWidth="4" />
                    </svg>
                </div>
                <div className="mdc-circular-progress__indeterminate-container">
                    <div className="mdc-circular-progress__spinner-layer">
                        <div className="mdc-circular-progress__circle-clipper mdc-circular-progress__circle-left">
                            <svg className="mdc-circular-progress__indeterminate-circle-graphic" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="24" cy="24" r="18" strokeDasharray="113.097" strokeDashoffset="56.549" strokeWidth="4" />
                            </svg>
                        </div>
                        <div className="mdc-circular-progress__gap-patch">
                            <svg className="mdc-circular-progress__indeterminate-circle-graphic" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="24" cy="24" r="18" strokeDasharray="113.097" strokeDashoffset="56.549" strokeWidth="3.2" />
                            </svg>
                        </div>
                        <div className="mdc-circular-progress__circle-clipper mdc-circular-progress__circle-right">
                            <svg className="mdc-circular-progress__indeterminate-circle-graphic" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="24" cy="24" r="18" strokeDasharray="113.097" strokeDashoffset="56.549" strokeWidth="4" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
    );
}
export default CircularProgress;
